
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import { sendGTMEvent } from "@/utils";

interface ActivationViewData {
  message: String;
}

export default defineComponent({
  data(): ActivationViewData {
    return {
      message: "Aktywacja konta...",
    };
  },
  mounted() {
    this.activation({
      uidb64: this.$route.params.uidb64,
      token: this.$route.params.token,
    }).then((status) => {
      if (status === "activated") {
        this.message =
          "Twoje konto zostało zaktywowane. Za chwilę przekierujemy Cię na listę napraw.";
        sendGTMEvent(
          {
            event: "rejestracja",
            "login-method": "email",
          },
          () => {}
        );
        setTimeout(() => {
          this.pullCars().then(() => {
            const typeId = this.getSelectedCar?.typeId;
            if (typeId) {
              this.$router.push({
                name: "tec-estimate-list",
                params: { typeId: typeId },
              });
            } else {
              this.$router.push({ name: "index" });
            }
          });
        }, 100);
      } else if (status === "alreadyActive") {
        this.message = "Twoje konto jest już aktywne. Zaloguj się.";
      } else {
        this.message = "Token jest niepoprawny albo wygasł.";
      }
    });
  },
  methods: {
    ...mapActions("accounts", ["activation"]),
    ...mapActions("cars", ["pullCars"]),
  },
  computed: {
    ...mapGetters("cars", ["getSelectedCar"]),
  },
  hideCarHeader: true,
});
